import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { HardDriveDownload } from 'lucide-react';

interface RecoverEditsDialogProps {
  open: boolean;
  onRecover: () => void;
  onDiscard: () => void;
}

export function RecoverEditsDialog({
  open,
  onRecover,
  onDiscard,
}: RecoverEditsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => { if (!isOpen) onDiscard(); }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <HardDriveDownload className="h-5 w-5 text-blue-500" />
            Recover Unsaved Changes
          </DialogTitle>
          <DialogDescription>
            We found unsaved changes from a previous session. Would you like to restore them?
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <p className="text-sm text-gray-600">
            If you discard, the current saved snapshot will be loaded instead.
          </p>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onDiscard}>
            Discard
          </Button>
          <Button onClick={onRecover}>
            Restore Changes
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
